var _g, _g2, _path, _path2, _g3, _path3, _path4, _g4, _path5, _path6, _g5, _rect, _rect2, _path7, _rect3, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 89,
    rx: 16.5,
    ry: 18,
    stroke: "#2A3544",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5149 102.765C22.1014 107.045 12.5098 104.311 8.09155 96.6585",
    stroke: "#2A3544",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 118.5,
    rx: 16.5,
    ry: 14.5,
    stroke: "#2A3544",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.606 126.423C164.326 119.01 154.653 116.582 147 121",
    stroke: "#2A3544",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.5,
    cy: 88.5,
    rx: 16.5,
    ry: 15.5,
    stroke: "#2A3544",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 66C143.895 66 143 66.8954 143 68V86C143 87.1046 143.895 88 145 88H157C158.105 88 159 87.1046 159 86V68C159 66.8954 158.105 66 157 66H145ZM23 93C21.8954 93 21 93.8954 21 95V113C21 114.105 21.8954 115 23 115H35C36.1046 115 37 114.105 37 113V95C37 93.8954 36.1046 93 35 93H23ZM24 126C22.8954 126 22 126.895 22 128V136C22 137.105 22.8954 138 24 138H36C37.1046 138 38 137.105 38 136V128C38 126.895 37.1046 126 36 126H24ZM143 110C143 108.895 143.895 108 145 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H145C143.895 130 143 129.105 143 128V110Z",
    fill: "#273951"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_53",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 66,
    width: 138,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 66C143.895 66 143 66.8954 143 68V86C143 87.1046 143.895 88 145 88H157C158.105 88 159 87.1046 159 86V68C159 66.8954 158.105 66 157 66H145ZM23 93C21.8954 93 21 93.8954 21 95V113C21 114.105 21.8954 115 23 115H35C36.1046 115 37 114.105 37 113V95C37 93.8954 36.1046 93 35 93H23ZM24 126C22.8954 126 22 126.895 22 128V136C22 137.105 22.8954 138 24 138H36C37.1046 138 38 137.105 38 136V128C38 126.895 37.1046 126 36 126H24ZM143 110C143 108.895 143.895 108 145 108H157C158.105 108 159 108.895 159 110V128C159 129.105 158.105 130 157 130H145C143.895 130 143 129.105 143 128V110Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#546E7A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "#59C4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_53",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 13,
    width: 60,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#536DFE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 13,
    width: 60,
    height: 23,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 14.5C90.4477 14.5 90 14.9477 90 15.5C90 16.0523 90.4477 16.5 91 16.5V14.5ZM102.694 21.6875C103.065 22.0968 103.697 22.1281 104.107 21.7573C104.516 21.3865 104.547 20.7541 104.176 20.3448L102.694 21.6875ZM106.759 24.0473C106.504 23.5579 105.899 23.3686 105.41 23.6246C104.921 23.8806 104.731 24.4848 104.987 24.9742L106.759 24.0473ZM106.425 28.9559C106.54 29.4959 107.072 29.84 107.612 29.7244C108.152 29.6088 108.496 29.0773 108.38 28.5373L106.425 28.9559ZM91 16.5C95.6375 16.5 99.8065 18.4999 102.694 21.6875L104.176 20.3448C100.926 16.7563 96.2256 14.5 91 14.5V16.5ZM104.987 24.9742C105.636 26.2139 106.124 27.5501 106.425 28.9559L108.38 28.5373C108.041 26.9518 107.49 25.4448 106.759 24.0473L104.987 24.9742Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56C25 49.3726 30.3726 44 37 44H143C149.627 44 155 49.3726 155 56V126C155 146.987 137.987 164 117 164H63C42.0132 164 25 146.987 25 126V56Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_53",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56C25 49.3726 30.3726 44 37 44H143C149.627 44 155 49.3726 155 56V126C155 146.987 137.987 164 117 164H63C42.0132 164 25 146.987 25 126V56Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#FFB300"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 128,
    width: 68,
    height: 24,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 132,
    width: 60,
    height: 16,
    rx: 2,
    fill: "black",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 141H72L74 137L77 144L81 136L83 145L86 134L89 144L92 141H107L110 137L112 144L115 141H119",
    stroke: "#4EFAC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 76C125.747 76 140.001 93.4742 140 107C139.999 120.526 120.411 124 91 124C61.9528 124 40 120.526 40 107C40 93.4742 55.1142 76 91 76Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8176 110.654C60.2909 109.3 55.583 104.312 56.3023 99.513C57.0216 94.7139 62.8956 91.9211 69.4224 93.275C75.9491 94.629 80.657 99.617 79.9377 104.416C79.2184 109.215 73.3444 112.008 66.8176 110.654Z",
    fill: "#25A6F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.422 110.654C106.896 112.008 101.022 109.215 100.302 104.416C99.583 99.617 104.291 94.629 110.818 93.275C117.344 91.9211 123.218 94.7139 123.938 99.513C124.657 104.312 119.949 109.3 113.422 110.654Z",
    fill: "#25A6F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot14);
export default __webpack_public_path__ + "static/media/bot-14.aeab718c9f8d8dc2b3a8f3ef364b2b3e.svg";
export { ForwardRef as ReactComponent };